import { render, staticRenderFns } from "./game-card.vue?vue&type=template&id=9065ade8&"
import script from "./game-card.vue?vue&type=script&lang=js&"
export * from "./game-card.vue?vue&type=script&lang=js&"
import style0 from "./game-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports